import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-copy-03',
  standalone: true,
  templateUrl: './rt-icon-copy-03.component.html',
  styleUrls: ['./rt-icon-copy-03.component.scss']
})
export class RtIconCopy03Component {
  @Input() width: number | string = 13;
  @Input() height: number | string = 13;
}
